import { useEffect, useState } from 'react';
import { useWatch } from 'react-hook-form';
import {
  SimpleForm,
  TextInput,
  SelectInput,
  AutocompleteInput,
  required
} from 'react-admin';
import { fetchAccounts } from '../../../../utils/accountUtils';
import { getSelectedIndustryId } from '../../../../utils/industryUtils';
import { validateJsonField } from '../../../../utils/validationUtils';
import { PLATFORMS } from '../../../../config/constants/reportConstants';
import {
  ADS_ACTION_ENTITY_TYPES,
  ADS_ACTION_NAMES,
  ADS_ACTION_PARAM_HINTS
} from '../../../../helpers/adsActionsConstants';

const ParamsInput = () => {
  const action = useWatch({ name: 'action' });
  const hint = ADS_ACTION_PARAM_HINTS[action];
  return (
    <TextInput
      source="params"
      label="Params (JSON)"
      multiline
      minRows={2}
      validate={validateJsonField}
      helperText={hint ? `e.g. ${hint}` : 'JSON object'}
      className="input-width-lg"
    />
  );
};

export const AdsActionsForm = (props) => {
  const [accounts, setAccounts] = useState([]);

  useEffect(() => {
    const loadAccounts = async () => {
      const { account_names } = await fetchAccounts({
        platforms_filter: [PLATFORMS.GOOGLE],
        industry_id: getSelectedIndustryId()
      });
      setAccounts(account_names || []);
    };

    loadAccounts();
  }, []);

  return (
    <SimpleForm {...props}>
      <AutocompleteInput
        source="internal_account_id"
        label="Account"
        choices={accounts}
        optionText="name"
        optionValue="id"
        validate={required()}
        className="input-width-lg"
      />
      <SelectInput
        source="entity_type"
        label="Entity Type"
        choices={ADS_ACTION_ENTITY_TYPES}
        validate={required()}
        className="input-width-md"
      />
      <SelectInput
        source="action"
        label="Action"
        choices={ADS_ACTION_NAMES}
        validate={required()}
        className="input-width-md"
      />
      <TextInput
        source="entity_id"
        label="Entity ID"
        validate={required()}
        helperText="Keywords: <ad_group_id>:<criterion_id>"
      />
      <ParamsInput />
      <TextInput
        source="expected_before"
        label="Expected before (JSON)"
        multiline
        minRows={2}
        validate={validateJsonField}
        helperText='e.g. {"status":"ENABLED"}'
        className="input-width-lg"
      />
      <TextInput
        source="reason"
        label="Reason"
        multiline
        minRows={2}
        validate={required()}
        className="input-width-lg"
      />
    </SimpleForm>
  );
};
